<template>
  <div style="width: 100%;height: 100%;overflow: auto">
    <div style="display: flex;margin-top: 10px">
      <div style="width: 300px;margin-left: 10px; font-size: 18px"><b>新客户数据：</b></div>
      <el-select v-model="customerYear" style="width: 200px" @change="initCustomerData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="customerCompany" style="width:200px;margin-left: 10px" @change="initCustomerData">
        <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>

    <div style="height: 300px;display: flex;margin-top: 10px">
      <div style="width: 49%;height: 100%;" id="monthlyData"></div>
      <div style="width: 49%;height: 100%;" id="customerAccumulateData"></div>
    </div>

    <div style="display: flex;margin-top: 10px">
      <div style="width: 300px;margin-left: 10px;font-size: 18px"><b>客户多产品附着率：</b></div>
      <el-select v-model="moreProductYear" style="width: 200px" @change="initMoreProductData">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="moreProductCompany" style="width:200px;margin-left: 10px" @change="initMoreProductData">
        <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div style="width: 99%;height:300px;" id="moreProductChart"></div>

    <div style="display: flex;margin-top: 10px">
      <div style="width: 300px;margin-left: 10px;font-size: 18px"><b>2/3D客户转化数：</b></div>
    </div>
    <div style="width: 99%;height: 300px;" id="twoAndThreeChart"></div>
  </div>

</template>

<script>
import * as echarts from "echarts";
import dayjs from "dayjs";

export default {
  name: "CustomerData",

  data() {
    return {
      customerYear:'',
      yearList:[],
      customerCompany:'summaryData',
      companyList:[],
      moreProductYear:'',
      moreProductCompany:'summaryData',
      customerMonthData:[],
      customerAccumulateData:[],
      moreProductData:[],
      twoAndThreeXData:[],
      twoAndThreeSeriesData:[],

    }
  },

  async created() {
    await this.getYearList();
    await this.getCompanyList();
    await this.initCustomerData();
    await this.initMoreProductData();
    await this.initTwoAndThreeData();

  },
  methods:{

    async initCustomerData(){
      await this.getNewCustomerData();
      await this.renderEcharts('customer');

    },
    async initMoreProductData(){
      await this.getMoreProductData();
      await this.renderEcharts('moreProductChart');
    },

    async initTwoAndThreeData(){
      await this.getTwoAndThreeData();
      await this.renderEcharts('twoAndThreeChart');
    },

    async getNewCustomerData(){
      let params = {year:this.customerYear,company:this.customerCompany}
      let data = await this.$http('crmBusinessService.getNewCustomerData',params);
      if(!data){
        return;
      }
      this.customerMonthData = data?.monthData;
      this.customerAccumulateData = data?.accumulateData;
    },

    async getMoreProductData(){
      let params = {year:this.moreProductYear,company:this.moreProductCompany}
      this.moreProductData = await this.$http('crmBusinessService.getMoreProductData',params);
    },
    async getTwoAndThreeData(){
      let data = await this.$http('crmBusinessService.getTwoAndThreeData');
      this.twoAndThreeXData = data?.lengthData;
      this.twoAndThreeSeriesData = data?.seriesData;
    },

    async getYearList(){
      const now = dayjs();
      this.customerYear = now.year() + '';
      this.moreProductYear = now.year() + '';
      this.yearList = await this.$http('sysDsService.getYears(10,1)');
    },
    async getCompanyList(){
      let data = await this.$http('crmTeamService.getCompanyList');
      data.unshift({value:'summaryData',label:'汇总数据'})
      this.companyList = data;
    },

    async renderEcharts(type) {
      if(type === 'customer'){
        const monthlyChartDom = document.getElementById('monthlyData');
        const customerAccumulateChartDom = document.getElementById('customerAccumulateData');
        // 获取现有的 ECharts 实例（如果有）
        let monthlyChart = echarts.getInstanceByDom(monthlyChartDom);
        // 获取现有的 ECharts 实例（如果有）
        let customerAccumulateChart = echarts.getInstanceByDom(customerAccumulateChartDom);
        // 如果存在现有的实例，销毁它
        if (monthlyChart) {
          monthlyChart.dispose();
        }
        // 如果存在现有的实例，销毁它
        if (customerAccumulateChart) {
          customerAccumulateChart.dispose();
        }
        // 初始化新的 ECharts 实例
        monthlyChart = echarts.init(monthlyChartDom);
        monthlyChart.setOption(this.getMonthlyChartOptions(), true);
        // 初始化新的 ECharts 实例
        customerAccumulateChart = echarts.init(customerAccumulateChartDom);
        customerAccumulateChart.setOption(this.getCustomerAccumulateOptions(), true);
      }

      if(type === 'moreProductChart'){
        const moreProductChartDom = document.getElementById('moreProductChart');
        // 获取现有的 ECharts 实例（如果有）
        let moreProductChart = echarts.getInstanceByDom(moreProductChartDom);
        // 如果存在现有的实例，销毁它
        if (moreProductChart) {
          moreProductChart.dispose();
        }
        // 初始化新的 ECharts 实例
        moreProductChart = echarts.init(moreProductChartDom);
        moreProductChart.setOption(this.getMoreProductChartOptions(), true);
      }
      if(type === 'twoAndThreeChart'){
        const twoAndThreeChartDom = document.getElementById('twoAndThreeChart');
        // 获取现有的 ECharts 实例（如果有）
        let twoAndThreeChart = echarts.getInstanceByDom(twoAndThreeChartDom);
        // 如果存在现有的实例，销毁它
        if (twoAndThreeChart) {
          twoAndThreeChart.dispose();
        }
        // 初始化新的 ECharts 实例
        twoAndThreeChart = echarts.init(twoAndThreeChartDom);
        twoAndThreeChart.setOption(this.getTwoAndThreeChartOptions(), true);
      }
    },

    getMonthlyChartOptions(){
      return{
        title: {
          text: '每月数据：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
        },
        yAxis: {
          type: 'value'
        },
        series: this.customerMonthData
      }
    },

    getCustomerAccumulateOptions(){
      return{
        title: {
          text: '累计数据：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
        },
        yAxis: {
          type: 'value'
        },
        series: this.customerAccumulateData
      }
    },

    getMoreProductChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
        },
        yAxis: {
          type: 'value'
        },
        series: this.moreProductData === undefined ? [] : this.moreProductData
      }
    },
    getTwoAndThreeChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.twoAndThreeXData === undefined ? [] : this.twoAndThreeXData
        },
        yAxis: {
          type: 'value'
        },
        series: this.twoAndThreeSeriesData === undefined ? [] : this.twoAndThreeSeriesData
      }
    },

  }
}
</script>

<style scoped>

</style>